
import api from "../api";


// CRUD
export const get = (id = '') => {
    return api.get(`/vehicle/${id}`);
};

export const create = (vehicle) => {
    return api.post(`/vehicles/vehicle`, vehicle);
};

export const update = (vehicle) => {
    return api.post(`/update-vehicles/vehicle`, vehicle);
};

export const remove = (vehicle) => {
    return api.delete(`/vehicle/${vehicle.id}`);
};


// Fetch and Search
export const latest = (offset = 0, amount = 20) => {
    return api.get(`/vehicles/all-vehicles`);
};

export const search = (searchParameters = [], offset = 0, amount = 20) => {
    return api.post(`/vehicles/${offset}/${amount}`, searchParameters);
};
